export default "__VITE_ASSET__315bb338__"